import { defineMessages } from 'react-intl';

export default defineMessages({
    noTaxAndSurcharge: {
        id: 'premiumreport.gl.page.premiums.N/A',
        defaultMessage: 'N/A'
    },
    cancelBtn: {
        id: 'premiumreport.gl.page.premiums.Cancel',
        defaultMessage: 'Cancel'
    },
    previousBtn: {
        id: 'premiumreport.gl.page.premiums.Previous',
        defaultMessage: 'Previous'
    },
    editBtn: {
        id: 'premiumreport.gl.page.premiums.Edit',
        defaultMessage: 'Edit'
    },
    saveBtn: {
        id: 'premiumreport.gl.page.premiums.Save',
        defaultMessage: 'Save'
    },
    submitBtn: {
        id: 'premiumreport.gl.page.premiums.Submit',
        defaultMessage: 'Submit'
    }
});
